import { apiClient } from '../api/apiClient';

const KsefService = {
  /**
   * Validates the KSeF token by calling the backend or KSeF API.
   * @param {string} token - The KSeF token to validate.
   * @returns {Promise<{success: boolean, message?: string}>}
   */
  validateToken: async (token) => {
    // Mocking the validation as requested.
    // In the future, this will call apiClient.post('/ksef/validate', { token })
    return new Promise((resolve) => {
      setTimeout(() => {
        if (!token) {
          resolve({ success: false, message: 'No token provided' });
        } else {
          resolve({ success: true });
        }
      }, 500);
    });
  },

  /**
   * Gets the current KSeF status from the API.
   * @returns {Promise<{status: 'none' | 'valid' | 'error', lastError?: string}>}
   */
  getStatus: async () => {
    try {
      const response = await apiClient.get('/setup/ksef-status');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch KSeF status', error);
      return { status: 'error', lastError: error.message };
    }
  }
};

export default KsefService;
